// https://redux.js.org/recipes/reducing-boilerplate/#generating-reducers
export const createReducer = (initialState, handlers) => (state = initialState, action) => {
  if ({}.hasOwnProperty.call(handlers, action.type)) {
    return handlers[action.type](state, action);
  }
  return state;
};

export default createReducer;
